<template>
  <div class="qr-page">
    <div class="card qr-card">
      <div v-if="state === 'loading'" class="state-block">
        <div class="loader" />
      </div>

      <div v-else-if="state === 'not_found'" class="state-block">
        <div class="state-icon">🔍</div>
        <h2>Inscrição não encontrada</h2>
        <p>Confira o link.</p>
      </div>

      <template v-else>
        <header class="header">
          <p class="header-eyebrow">SEU INGRESSO</p>
          <h1>{{ inscricao.evento.nome }}</h1>
          <p class="participante">{{ inscricao.participanteNome }}</p>
          <p v-if="periodoFmt" class="periodo">{{ periodoFmt }}</p>
        </header>

        <div v-if="inscricao.statusPagamento !== 'QUITADA'" class="aviso aviso-warn">
          <strong>Pagamento pendente.</strong>
          Quando você quitar a inscrição, o QR aparece aqui automaticamente.
        </div>

        <div v-else-if="!inscricao.evento.temCheckin" class="aviso aviso-info">
          <strong>Tudo certo!</strong>
          Esse evento não usa código de check-in. Sua inscrição já está confirmada.
        </div>

        <template v-else>
          <div v-if="inscricao.checkInStatus === 'CONFIRMADO'" class="confirmado">
            <div class="check-icon">✅</div>
            <h3>Check-in já realizado</h3>
            <p>Confirmado em {{ formatDateTime(inscricao.checkInAt) }}.</p>
          </div>

          <div v-else class="qr-wrap">
            <p class="qr-instructions">
              Apresente este QR Code na entrada do evento.
            </p>
            <div class="qr-box">
              <qrcode-vue :value="inscricao.id" :size="qrSize" level="M" />
            </div>
            <p class="qr-id">
              <span class="muted">Código:</span> {{ inscricao.id }}
            </p>
            <p class="qr-help">
              Salva uma captura de tela. Sem internet, mostre o QR direto da galeria.
            </p>
          </div>
        </template>

        <ReenviarEmailLink :inscricao-id="inscricao.id" />

        <footer class="footer">
          <p>Nova Aliança El Shaday · Aliança Jovem</p>
        </footer>
      </template>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import { getQrInfoPublico } from '../../lib/checkin'
import ReenviarEmailLink from '../../components/ui/ReenviarEmailLink.vue'

export default {
  name: 'MeuQrPage',
  components: { QrcodeVue, ReenviarEmailLink },
  data() {
    return {
      state: 'loading',
      inscricao: null,
      qrSize: 280
    }
  },
  computed: {
    periodoFmt() {
      const e = this.inscricao?.evento
      if (!e?.dataInicio) return null
      try {
        const i = new Date(e.dataInicio).toLocaleDateString('pt-BR')
        if (!e.dataFim) return i
        const f = new Date(e.dataFim).toLocaleDateString('pt-BR')
        return `${i} a ${f}`
      } catch { return null }
    }
  },
  async mounted() {
    try {
      this.inscricao = await getQrInfoPublico(this.$route.params.inscricaoId)
      this.state = 'ready'
    } catch (err) {
      this.state = err.response?.status === 404 ? 'not_found' : 'ready'
    }
    this.qrSize = Math.min(320, window.innerWidth - 96)
  },
  methods: {
    formatDateTime(d) {
      try { return new Date(d).toLocaleString('pt-BR') } catch { return d }
    }
  }
}
</script>

<style scoped>
.qr-page {
  min-height: 100vh;
  display: flex; justify-content: center; align-items: flex-start;
  padding: clamp(16px, 4vw, 32px);
}
.qr-card {
  width: 100%; max-width: 480px;
  padding: clamp(24px, 5vw, 40px);
  display: flex; flex-direction: column; gap: clamp(20px, 3vw, 28px);
}
.state-block {
  display: flex; flex-direction: column; align-items: center; gap: 12px;
  padding: 40px 0; text-align: center;
}
.state-icon { font-size: 48px; }
.loader {
  width: 32px; height: 32px;
  border: 3px solid var(--color-bg-separator);
  border-top-color: var(--color-accent);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
.header { text-align: center; }
.header-eyebrow {
  font-size: 11px; letter-spacing: 4px;
  color: var(--color-text-muted); text-transform: uppercase;
  margin: 0 0 8px;
}
h1 { font-size: clamp(20px, 3vw, 26px); margin: 0 0 6px; }
.participante {
  font-weight: 600; color: var(--color-text-primary);
  margin: 0 0 4px;
}
.periodo { font-size: var(--text-sm); color: var(--color-text-muted); margin: 0; }
.aviso {
  padding: 16px;
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  line-height: 1.5;
}
.aviso-warn { background: #fef3c7; color: #78350f; }
.aviso-info { background: #dbeafe; color: #1e40af; }
.confirmado {
  text-align: center;
  padding: 24px;
  background: #dcfce7;
  border-radius: var(--radius-md);
}
.check-icon { font-size: 56px; line-height: 1; }
.confirmado h3 { color: #14532d; margin: 12px 0 8px; }
.confirmado p { color: #166534; margin: 0; }
.qr-wrap {
  display: flex; flex-direction: column; align-items: center; gap: 14px;
}
.qr-instructions { text-align: center; font-size: var(--text-sm); color: var(--color-text-secondary); margin: 0; max-width: 320px; }
.qr-box {
  padding: 16px;
  background: #fff;
  border-radius: var(--radius-md);
  box-shadow: 0 4px 14px rgba(0,0,0,0.12);
}
.qr-id {
  font-family: monospace; font-size: 11px;
  word-break: break-all; text-align: center;
  margin: 0;
  color: var(--color-text-secondary);
}
.muted { color: var(--color-text-muted); }
.qr-help {
  text-align: center;
  font-size: var(--text-xs);
  color: var(--color-text-muted);
  margin: 0; max-width: 320px;
}
.footer {
  text-align: center;
  padding-top: 16px;
  border-top: 1px solid var(--color-bg-separator);
  color: var(--color-text-muted);
  font-size: var(--text-xs);
}
</style>
